import { SitemapDate } from 'models';

export const isExternalUrl = (url: string): boolean =>
	url.startsWith('http://') || url.startsWith('https://');


export const toDateString = (value: SitemapDate | undefined): string | undefined => {
	if (value == null) return undefined;
	return value instanceof Date ? value.toISOString() : value;
};